export default function validationBrief(brief, errors) {
  if (!brief.produitLocation) {
    errors.push({ message: 'ajoutReseauLc.errors.produitLoc' });
  }
  if (!brief.dateVisualisation.dateDebut || !brief.dateVisualisation.dateFin) {
    errors.push({ message: 'ajoutReseauLc.errors.datesRequired' });
  }
  if (brief.dateVisualisation.dateFin && brief.dateVisualisation.dateDebut
    && brief.dateVisualisation.dateDebut > brief.dateVisualisation.dateFin) {
    errors.push({ message: 'ajoutReseauLc.errors.dateDebutGreaterDateFin' });
  }
}
